import React from 'react';

/**
 * ArcadeMark — marque maison d'Arcade Fleet : une borne d'arcade upright.
 * Signatures qui la rendent identifiable (et non un "téléphone") :
 *  - marquee en casquette qui DÉBORDE au sommet
 *  - deck de contrôle qui AVANCE (joystick + boutons en saillie)
 *  - porte à monnaie en bas
 * Couleurs par tokens : structure = currentColor ; écran = --secondary ; blip = --tertiary.
 */
const ArcadeMark = ({ className = '', title = 'Arcade Fleet' }) => (
  <svg
    viewBox="0 0 32 32"
    className={className}
    role="img"
    aria-label={title}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* marquee — casquette qui déborde du corps */}
    <rect x="7.5" y="3" width="17" height="3.6" rx="1" fill="currentColor" />
    {/* corps de la borne */}
    <rect x="9.6" y="6.4" width="12.8" height="21.6" rx="1.4" stroke="currentColor" strokeWidth="1.6" />
    {/* écran incliné (trapèze plus large en haut) */}
    <path d="M11.4 8.5 L20.6 8.5 L20 13.9 L12 13.9 Z" fill="hsl(var(--secondary))" />
    <circle cx="16" cy="11.1" r="1.1" fill="hsl(var(--tertiary))" />
    {/* deck de contrôle en saillie (trapèze qui dépasse le corps) */}
    <path d="M8.2 15.3 L23.8 15.3 L22.6 18.6 L9.4 18.6 Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    {/* joystick */}
    <line x1="12.4" y1="17.7" x2="12.4" y2="16.2" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
    <circle cx="12.4" cy="15.9" r="1.15" fill="currentColor" />
    {/* boutons */}
    <circle cx="16.5" cy="17" r="0.95" fill="currentColor" />
    <circle cx="19.1" cy="16.7" r="0.95" fill="currentColor" />
    {/* porte à monnaie */}
    <rect x="13.3" y="22.4" width="5.4" height="4.1" rx="0.6" stroke="currentColor" strokeWidth="1.2" />
    <rect x="15.4" y="23.4" width="1.2" height="0.9" rx="0.2" fill="currentColor" />
  </svg>
);

export default ArcadeMark;
